var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg053Heart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.67,79.174C446.515,53.701,411.829,39.672,374,39.672c-66.136,0-100.331,34.03-117.371,62.577 c-0.212,0.354-0.422,0.709-0.629,1.063c-0.207-0.354-0.417-0.709-0.629-1.063C238.331,73.702,204.136,39.672,138,39.672 c-37.829,0-72.515,14.029-97.67,39.503C13.946,105.894,0,142.469,0,184.946c0,90.198,80.181,150.001,150.922,202.764 c35.249,26.29,68.543,51.123,89.498,77.158c3.796,4.717,9.525,7.46,15.58,7.46s11.784-2.743,15.581-7.458 c10.778-13.392,25.76-27.631,47.152-44.812c8.611-6.917,9.985-19.506,3.068-28.118c-6.916-8.61-19.505-9.986-28.117-3.069 c-15.092,12.122-27.436,23.085-37.675,33.503c-22.608-23.047-51.223-44.39-81.172-66.727C108.547,306.204,40,255.077,40,184.946 c0-61.984,40.299-105.274,98-105.274c37.519,0,65.223,14.115,82.34,41.952c13.59,22.097,15.704,45.098,15.718,45.24 c0.802,10.419,9.488,18.508,19.937,18.508c10.451,0,19.136-8.001,19.938-18.42c0.021-0.23,2.135-23.231,15.725-45.328 C308.777,93.787,336.481,79.672,374,79.672c57.701,0,98,43.29,98,105.274c0,58.038-47.252,103.036-98.315,143.017 c-8.696,6.809-10.227,19.38-3.417,28.077c6.807,8.696,19.379,10.227,28.077,3.417c24.29-19.019,55.077-44.72,77.723-74.901 C500.246,252.333,512,219.75,512,184.946C512,142.469,498.054,105.894,471.67,79.174z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg053Heart);
export default __webpack_public_path__ + "static/media/053-heart.b95decf723e02f76a237dc54106c8038.svg";
export { ForwardRef as ReactComponent };